export default {
  data() {
    return {
      recaptcha_is_v2: this.$config('recaptcha_is_v2'),
      captcha_token: ''
    };
  },

  mounted: function () {
    if (this.recaptcha_is_v2) {
      this.mountCaptchaV2();
    }
  },

  watch: {
    recaptcha_is_v2: function () {
      this.mountCaptchaV2();
    }
  },

  methods: {
    submitCaptcha(callback) {
      if (this.recaptcha_is_v2 || !window.grecaptcha) {
        callback();
      } else {
        this.getCaptchaV3Token(callback);
      }
    },

    mountCaptchaV2() {
      let sitekey = this.$config('recaptcha2_public_key');
      window.grecaptcha.render('captcha_button', {
        sitekey,
        callback: token => {
          this.captcha_token = token;
        }
      });
    },

    getCaptchaV3Token(callback) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(this.$config('recaptcha3_public_key'), { action: 'login_planbuilder' }).then(token => {
          this.captcha_token = token;
          callback();
        });
      });
    }
  }
};
